import Joi from '@hapi/joi'

const createSchema = (allowTLD?: string[]) => Joi.string().email({ tlds: { allow: allowTLD } })

export const validateEmail = (email: string, allowTLD?: string[]) => {
    const emailSchema = createSchema(allowTLD)

    const validation = emailSchema.validate(email)
    return validation.error ? false : true
}
